import apiClient from './apiClient';
import { unwrapResponse } from './unwrapResponse';
import type { AppNotification } from '@/types/api';

export const notificationsApi = {
  list: async (page = 1, limit = 20): Promise<AppNotification[]> => {
    const res = await apiClient.get(`/member/notifications?page=${page}&limit=${limit}`);
    return unwrapResponse<AppNotification[]>(res);
  },

  unreadCount: async (): Promise<number> => {
    const res = await apiClient.get('/member/notifications/unread-count');
    const data = unwrapResponse<{ unreadCount: number }>(res);
    return data.unreadCount;
  },

  // Response is `{ success, data: NotificationResource }`, and NotificationResource itself
  // has a field named `data` — unwrapResponse's generic `{data:{data}}` unwrap would collide
  // with that and return the notification's payload instead of the notification. The caller
  // only needs the request to succeed (store already applies the optimistic update locally).
  markRead: async (id: number | string): Promise<void> => {
    await apiClient.post(`/member/notifications/${id}/read`);
  },

  markAllRead: async (): Promise<void> => {
    await apiClient.post('/member/notifications/read-all');
  },

  remove: async (id: number | string): Promise<void> => {
    await apiClient.delete(`/member/notifications/${id}`);
  },
};

export default notificationsApi;
